import React, {Fragment} from 'react';
import styled from 'styled-components';
import {
  Edit as EditIcon, 
  AlarmAdd as AlarmAddIcon, 
  NotificationsNone as NotificationIcon} from "@material-ui/icons";
import BreadCrumbGrid from 'components/Global/BreadCrumb/BreadCrumbGrid'
import { Link} from "react-router-dom";
import { Toolbar} from '@material-ui/core';
import {SecondaryButton, NotesButton,AttachmentsButton, CancelButton, SaveButton, SaveAndReturnButton} from 'components/Global/Buttons';
import HedgeAttachments from "components/Global/OptionsMenu/HedgeTable/HedgeAttachments";
import PageWrapper from 'components/Global/PageOrganization/PageWrapper';
import HedgeNotes from "components/Global/OptionsMenu/HedgeTable/HedgeNotes";

const Title = styled.div`
font-size:24px;
color: #333333;
`
const VerticalDivider = styled.div`
height:20px;
background:#d7d7d7;
width: ${props => props.width ? props.width+'px' : '1px'};
`
const Spacer = styled.div`
flex-grow:1;
`
const ShadowyPageWrapper = styled.div`
  && {
    box-shadow: 0 0 3px grey;
    padding: 15px 10px;   
    margin-bottom:16px;     
  }
`
const OrganicLink = ({to, targetId, children, placeholder, ...other}) => {
  if(targetId === 'free')
    return null;
  return <Link to={to} {...other}>{children}</Link>  
}

const EditButton = ({onClick}) => (
  <SecondaryButton id="editHedgeButton" onClick={onClick}>
    <EditIcon/>
    <div>EDIT Hedge</div>
  </SecondaryButton>
)

class HedgeDetailsToolbar extends React.Component {
  state ={
    isAttachmentsOpen:false,
    isNotesOpen: false,
  }

  openNotes = () => this.setState({ isNotesOpen: true });
  closeNotes = () => this.setState({ isNotesOpen: false });  
  openAttachments = () => this.setState({ isAttachmentsOpen: true });  
  closeAttachments = () => this.setState({ isAttachmentsOpen: false });  

  renderViewModeButtons = () => {
    if(!this.props.isEditing){
      return (!this.props.authentication.isGuest || (this.props.authentication.isGuest && this.props.guestPermissions.canEdit)) && (
        <Fragment>
          <EditButton onClick={this.props.onOpenEditMode}/>
        </Fragment>
      )
    }
  }

  renderEditModeButtons = () => {
    if(this.props.isEditing){
      return (
        <Fragment>
          <CancelButton id="cancelButton" onClick={this.props.onCancel}/>
          <SaveButton id="saveButton" onClick={this.props.onSave}/>
          <SaveAndReturnButton id="saveAndReturnButton" onClick={this.props.onSaveAndReturn}/>
        </Fragment>
      )
    }
  }

  render(){
    const {fund, deal, hedge} = this.props;
    const hedgeId = hedge.id;
    const {isAttachmentsOpen, isNotesOpen} = this.state;
    return (
    <ShadowyPageWrapper>
      {!this.props.authentication.isGuest && <BreadCrumbGrid>
        <OrganicLink to={`/portfolio`}>Portfolio / </OrganicLink>
        <OrganicLink to={`/portfolio/funds/${fund.id}`} targetId={fund.id}>{fund.name} / </OrganicLink>
        <OrganicLink to={`/portfolio/funds/${fund.id}/deals/${deal.id}`} targetId={deal.id} >{deal.name} / </OrganicLink>        
        <OrganicLink to={`/hedge/${fund.id}/${deal.id}/${hedge.id}`}>{hedge.name} / Hedge Details</OrganicLink>
      </BreadCrumbGrid>}
      <Toolbar disableGutters>
        <Title>Hedge Details</Title>
        {this.renderViewModeButtons()}
        {this.renderEditModeButtons()}
        <Spacer/>
        <NotesButton onClick={this.openNotes}/>
        <VerticalDivider/>
        <AttachmentsButton onClick={this.openAttachments}/>
      </Toolbar>
      <HedgeAttachments
        hedgeId={hedgeId}
        isOpen={isAttachmentsOpen}
        openAttachments={this.openAttachments}
        closeAttachments={this.closeAttachments}
      />
      <HedgeNotes
        hedgeId={hedgeId}
        isOpen={isNotesOpen}
        openNotes={this.openNotes}
        closeNotes={this.closeNotes}
      />
    </ShadowyPageWrapper>
    )
  }
}

export default HedgeDetailsToolbar;